export enum TranslationKeys {
  PlanLoadingErrorModalHeader = 'jbp-plan-loading-error-header',
  PlanLoadingErrorModalText = 'jbp-plan-loading-error-text',
  PlanLoadingProgressBarModalText = 'jbp-plan-loading-progress-bar-text',
}
